"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.add = add;
exports.checkFlags = void 0;
exports.divide = divide;
exports.multiply = multiply;
exports.subtract = subtract;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 众所周知， 0.1 + 0.2 = 0.30000000000000004
// 所以这边提供了用于精确处理浮点数加减乘除的函数

/**
 * 获取一个数字的小数位数
 * @param num
 */
function getDecimalDigits(num) {
  var splitedNumber = String(num).split('.'); // 整数小数位数为 0

  if (splitedNumber.length < 2) {
    return 0;
  } // 这里无需考虑 getDecimalDigits('0.200')
  // 只要最后 convertFloatToInteger 最后转换完的结果不会超过 Number.MAX_VALUE 很多，就不会影响最后的结果，因为最后都会约掉的


  return splitedNumber[1].length;
}
/**
 * 将一个浮点数的小数点右移（10 进制）来将其转换为整数
 * 需注意：当转换的结果比 Number.MAX_VALUE 还要大时，可能会得到 Infinity
 * @param num
 */


function convertFloatToInteger(num) {
  return Number(String(num).replace('.', ''));
}
/**
 * 返回 10 的 x 次方
 * @param power
 */


function pow10(power) {
  return Math.pow(10, power);
}
/**
 * 精确计算加法
 * @param num1
 * @param num2
 */


function add(num1, num2) {
  var digits1 = getDecimalDigits(num1);
  var digits2 = getDecimalDigits(num2);
  var diff = Math.abs(digits1 - digits2);
  return (convertFloatToInteger(num1) * pow10(digits1 > digits2 ? 0 : diff) + convertFloatToInteger(num2) * pow10(digits2 > digits1 ? 0 : diff)) / pow10(Math.max(digits1, digits2));
}
/**
 * 精确计算减法（num1 - num2）
 * @param num1
 * @param num2
 */


function subtract(num1, num2) {
  return add(num1, -num2);
}
/**
 * 精确计算乘法
 * @param num1
 * @param num2
 */


function multiply(num1, num2) {
  var digits = 0;
  digits += getDecimalDigits(num1);
  digits += getDecimalDigits(num2);
  num1 = convertFloatToInteger(num1);
  num2 = convertFloatToInteger(num2);
  return num1 * num2 / pow10(digits);
}
/**
 * 精确计算除法（num1 / num2）
 * @param num1
 * @param num2
 */


function divide(num1, num2) {
  var digits1 = getDecimalDigits(num1);
  var digits2 = getDecimalDigits(num2);
  num1 = convertFloatToInteger(num1);
  num2 = convertFloatToInteger(num2);
  return num1 / num2 * pow10(digits2 - digits1);
}
/**
 * 使用类型安全的位运算来检查 value 是否满足条件
 * 可用于检查类型、权限等数据
 * @param value 待检查的值
 * @param flags flag 数组
 * @returns value & (flag1 | flag2 | ...)
 */


var checkFlags = function checkFlags(value) {
  for (var _len = arguments.length, flags = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    flags[_key - 1] = arguments[_key];
  }

  /* eslint-disable no-bitwise */
  var target = (0, _reduce.default)(flags).call(flags, function (prev, flag) {
    return prev | flag;
  }, 0);
  return !!(value & target);
  /* eslint-enable no-bitwise */
};

exports.checkFlags = checkFlags;